import Api, { ApiError } from '@teko/api';
export { ApiError } from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';
import i18next from 'i18next';

var viLang = {
	"Dữ liệu không hợp lệ": "Dữ liệu không hợp lệ",
	"Dữ liệu loyalty không hợp lệ": "Dữ liệu loyalty không hợp lệ",
	"Dữ liệu Takashimaya không hợp lệ": "Dữ liệu Takashimaya không hợp lệ",
	"Dữ liệu loyalty ngoài giá trị cho phép": "Dữ liệu loyalty ngoài giá trị cho phép",
	"Dữ liệu Takashimaya ngoài giá trị cho phép": "Dữ liệu Takashimaya ngoài giá trị cho phép",
	"Thành viên đã tồn tại": "Thành viên đã tồn tại",
	"Nhập thiếu giá trị bắt buộc": "Nhập thiếu giá trị bắt buộc",
	"Giá trị không nằm trong tập cho phép": "Giá trị không nằm trong tập cho phép",
	"Không có quyền truy cập Loyalty": "Không có quyền truy cập Loyalty",
	"Không có quyền truy cập Takashimaya": "Không có quyền truy cập Takashimaya",
	"Không có quyền truy cập": "Không có quyền truy cập",
	"Không tìm thấy cấu hình loyalty network": "Không tìm thấy cấu hình loyalty network",
	"Không tìm thấy chứng chỉ xác thực loyalty": "Không tìm thấy chứng chỉ xác thực loyalty",
	"Không tìm thấy loyalty tier": "Không tìm thấy loyalty tier",
	"Số điện thoại đã được sử dụng": "Số điện thoại đã được sử dụng",
	"Chứng chỉloyalty đã được sử dụng": "Chứng chỉloyalty đã được sử dụng",
	"Số điện thoại cho Takashimaya đã được sử dụng": "Số điện thoại cho Takashimaya đã được sử dụng",
	"Loyalty network không hoạt động": "Loyalty network không hoạt động",
	"Loyalty merchant không hoạt động": "Loyalty merchant không hoạt động",
	"Takashimaya network không hoạt động": "Takashimaya network không hoạt động",
	"Trả góp chỉ áp dụng cho đơn hàng có giá trị từ 3 triệu đồng trở lên": "Trả góp chỉ áp dụng cho đơn hàng có giá trị từ 3 triệu đồng trở lên"
};

var enLang = {
	"Dữ liệu không hợp lệ": "Invalid data",
	"Dữ liệu loyalty không hợp lệ": "Invalid loyalty data",
	"Dữ liệu Takashimaya không hợp lệ": "Invalid Takashimaya data",
	"Dữ liệu loyalty ngoài giá trị cho phép": "Loyalty data is out of range",
	"Dữ liệu Takashimaya ngoài giá trị cho phép": "Takashimaya data is out of range",
	"Thành viên đã tồn tại": "Member existed already",
	"Nhập thiếu giá trị bắt buộc": "Missing required fields",
	"Giá trị không nằm trong tập cho phép": "Inputted value is out of range",
	"Không có quyền truy cập Loyalty": "No permission to access loyalty",
	"Không có quyền truy cập Takashimaya": "No permission to access Takashimaya",
	"Không có quyền truy cập": "No access permission",
	"Không tìm thấy cấu hình loyalty network": "Loyalty network configuration not found",
	"Không tìm thấy chứng chỉ xác thực loyalty": "Loyalty authentication cert not found",
	"Không tìm thấy loyalty tier": "Loyalty tier not found",
	"Số điện thoại đã được sử dụng": "Phone number existed already",
	"Chứng chỉloyalty đã được sử dụng": "Loyatly cert has been used already",
	"Số điện thoại cho Takashimaya đã được sử dụng": "Phone number has been used for Takashimaya",
	"Loyalty network không hoạt động": "Loyalty network not working",
	"Loyalty merchant không hoạt động": "Loyalty merchant not working",
	"Takashimaya network không hoạt động": "Takashimaya network not working",
	"Trả góp chỉ áp dụng cho đơn hàng có giá trị từ 3 triệu đồng trở lên": "Installment only applies to orders with a value of 3 million VND or more"
};

const NAMESPACE = 'terra-bff';
const t = (keys, options) => {
    return i18next.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE, interpolation: { escapeValue: false } }));
};
const lang = {
    vi: viLang,
    en: enLang,
};

const errorMessageMapping = new Map([
    [400001, 'Dữ liệu không hợp lệ'],
    [400100, 'Dữ liệu loyalty không hợp lệ'],
    [400101, 'Dữ liệu loyalty ngoài giá trị cho phép'],
    [400102, 'Nhập thiếu giá trị bắt buộc'],
    [400120, 'Giá trị không nằm trong tập cho phép'],
    [
        400310,
        'Trả góp chỉ áp dụng cho đơn hàng có giá trị từ 3 triệu đồng trở lên',
    ],
    [400320, 'Dữ liệu Takashimaya không hợp lệ'],
    [400321, 'Dữ liệu Takashimaya ngoài giá trị cho phép'],
    [400322, 'Nhập thiếu giá trị bắt buộc'],
    [400330, 'Giá trị không nằm trong tập cho phép'],
    [403104, 'Không có quyền truy cập Loyalty'],
    [403116, 'Không có quyền truy cập loyalty'],
    [403116, 'Không có quyền truy cập'],
    [403331, 'Không có quyền truy cập Takashimaya'],
    [404117, 'Không tìm thấy cấu hình loyalty network'],
    [404123, 'Không tìm thấy chứng chỉ xác thực loyalty'],
    [404124, 'Không tìm thấy loyalty tier'],
    [409121, 'Số điện thoại đã được sử dụng'],
    [409125, 'Chứng chỉloyalty đã được sử dụng'],
    [409323, 'Thành viên đã tồn tại'],
    [409323, 'Thẻ thành viên này đã được liên kết với một tài khoản khác'],
    [409324, 'Số điện thoại và mã thẻ không trùng khớp'],
    [409328, 'Số điện thoại đã được sử dụng'],
    [409332, 'Số điện thoại cho Takashimaya đã được sử dụng'],
    [423122, 'Loyalty network không hoạt động'],
    [423126, 'Loyalty merchant không hoạt động'],
    [423333, 'Takashimaya network không hoạt động'],
    [
        429325,
        'Số điện thoại và mã thẻ không trùng khớp. Tạm khóa chức năng liên kết trong 1 giờ.',
    ],
    [500202, 'Vui lòng cập nhật số điện thoại'],
    [500329, 'Không cùng thuộc Takashimaya network'],
]);
const getError = (resp) => {
    const tKey = errorMessageMapping.get(resp.code);
    if (!tKey)
        return null;
    const message = t(tKey);
    return new ApiError(message, resp.code, resp);
};

class TerraService {
    constructor(apiUrl) {
        this.terraApi = new Api(apiUrl, getError);
        this.terraApi.addInterceptor(accessTokenInterceptor);
    }
    async linkTakaMembership(body, loyaltyClientId) {
        const url = '/api/v1/linkTakaMembership';
        const { data } = await this.terraApi.post(url, body, {
            headers: { 'X-Loyalty-Id': loyaltyClientId },
        });
        return data;
    }
    async getInstallmentTerms(merchantMethodCode, amount) {
        const { data } = await this.terraApi.get('/api/v1/payment/terms', {
            params: {
                merchantMethodCode,
                amount,
            },
        });
        return data;
    }
    async registerMembership(request, loyaltyClientId) {
        const url = '/api/v1/registerMember';
        const { data } = await this.terraApi.post(url, request, {
            headers: {
                'X-Loyalty-Id': loyaltyClientId,
            },
        });
        return data;
    }
    async getLoyaltyMemberInfo(loyaltyClientId) {
        const url = '/api/v1/loyalty/member';
        const { data } = await this.terraApi.get(url, {
            headers: { 'x-loyalty-id': loyaltyClientId },
        });
        return data;
    }
}

export { NAMESPACE, TerraService, lang };
